import { Build } from '@stencil/core';
/**
 * Check if the passed URL is valid.
 */
export const isValidUrl = (url) => {
    try {
        new URL(url);
    }
    catch (error) {
        return false;
    }
    return true;
};
/**
 * Checks if the url is an internal url.
 */
export const isInternalUrl = (targetUrl) => {
    if (!isValidUrl(targetUrl))
        return false;
    return window.location.host.includes(new URL(targetUrl).host.split('.').slice(1, 2).join());
};
/**
 * Changes the passed URL to an environment url if it is an internal URL.
 *
 * @example
 * const newUrl = envUrl('https://weinfreunde.de')
 * console.log(newUrl) // returns 'https://dev.weinfreunde.rdss.it
 */
export const envUrl = (url) => {
    if (!isInternalUrl(url))
        return url;
    return url.replace(new URL(url).host, window.location.host);
};
/**
 * Update URL with given url without reloading page.
 */
export const updateUrl = (url, replaceUrl = false) => {
    const newUrl = new URL(url);
    const originalUrl = new URL(location.href);
    for (const [key, value] of originalUrl.searchParams.entries()) {
        if (!['f', 'c', 's', 'o', 'p', 'skipsponsored'].includes(key)) {
            newUrl.searchParams.set(key, value);
        }
    }
    url = newUrl.href;
    if (url === null || url === void 0 ? void 0 : url.endsWith('?')) {
        url = url.slice(0, -1);
    }
    if (Build.isBrowser) {
        // If history back / forward and window location reload is triggered with same url -> don't update.
        if (window.location.href !== url) {
            if (replaceUrl) {
                window.history.replaceState({ url: url, manualPush: true, timestamp: Date.now() }, '', url);
            }
            else {
                window.history.pushState({ url: url, manualPush: true, timestamp: Date.now() }, '', url);
            }
        }
    }
};
/**
 *  If navigation from browser back / froward button then reload page.
 */
const reloadHistoryState = (event) => {
    if ((!event.state || event.state.manualPush) && document.querySelector('vx-filter-container')) {
        window.location.reload();
    }
};
/**
 *  Register Event that listing on popstate.
 */
export const registerHistoryNavigationListener = () => {
    if (Build.isBrowser) {
        window.addEventListener('popstate', reloadHistoryState);
    }
};
/**
 *  Remove Event that listing on popstate.
 */
export const unRegisterHistoryNavigationListener = () => {
    if (Build.isBrowser) {
        window.removeEventListener('popstate', reloadHistoryState);
    }
};
//# sourceMappingURL=url.js.map